// extracted by mini-css-extract-plugin
export default {"calendar":"calendar__SZ2dl","calendar__title":"calendar__title__rTord","calendar__main":"calendar__main__RpV4B"};